module.exports = __webpack_public_path__ + "static/media/profiles.55e5f032.svg";